import { updateSpkStatementQuickBooksVendor } from '../../../graphql/custom_mutations';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export const updateQBVendor = async (props) => {
  if (!props) return;
  console.log('updateQBVendor props: ', props);
  try {
    const gqlParams = { input: props };
    console.log('gqlParams: ', gqlParams);
    const response = await client.graphql({
      query: updateSpkStatementQuickBooksVendor,
      variables: gqlParams
    });
    console.log('updateQBVendor response: ', response);
    const results = response.data.updateSpkStatementQuickBooksVendorTbl.qbId;
    console.log('updateQBVendor results: ', results);
    return results;
  } catch (err) {
    return ('error updateQBVendor: ', [err]);
  }
};

updateQBVendor.propTypes = {
  props: PropTypes.object.isRequired,
};